import { useSelector } from 'react-redux';

import { AppState } from 'models/app-store';
import { SettingsCategories } from 'models/settings';
import { GeoSystemTypes } from 'utils/enums/geo-system-types';
import { useCallback } from 'react';

const useMeasureSystemType = (): MeasureSystem => {
  const measureType: GeoSystemTypes =
    useSelector((state: AppState) => state.settings.settings?.[SettingsCategories.Geolocation].systemType) || GeoSystemTypes.Metric;

  const converter = useCallback(
    (value?: number | null, fromUnit: 'meters' | 'feet' = 'meters', toUnit: 'kilometers' | 'meters' = 'kilometers') => {
      if (!value) {
        return 0;
      }

      const meters = fromUnit === 'feet' ? value * 0.3048 : value;

      if (toUnit === 'meters') {
        return meters;
      }

      return measureType === GeoSystemTypes.Metric ? (meters / 1000) : ((meters / 1000) * 0.621371);
    },
    [measureType],
  );

  const inverseConverter = useCallback(
    (displayValue?: number | null): number => {
      if (!displayValue) {
        return 0;
      }

      return measureType === GeoSystemTypes.Metric ? displayValue : displayValue / 0.621371;
    },
    [measureType],
  );

  return {
    converter,
    inverseConverter,
    geoSystemType: measureType,
  };
};

export type MeasureSystem = {
  geoSystemType: GeoSystemTypes;
  converter: (value?: number | null, fromUnit?: 'meters' | 'feet', toUnit?: 'kilometers' | 'meters') => number;
  inverseConverter: (displayValue?: number | null) => number;
};

export default useMeasureSystemType;
